let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1Zesg")).then(() => parcelRequire('7fZ9R'));